import { AdminPage, AdminPageHeader } from '../../components/layout/AdminPage';
/**
 * @page EmailSettingsPage
 * @description Unavailable state for the unfinished report settings editor.
 */

import { useTranslation } from 'react-i18next';

export default function EmailSettingsPage() {
  const { t } = useTranslation('accounting');

  return (
    <AdminPage
      contentClassName="admin-content-short"
      header={<AdminPageHeader title={t('emailSettingsTitle')} />}
    >
      <p
        role="status"
        className="bg-base-200 border border-base-300 rounded-xl p-5 text-base-content/80"
      >
        {t('emailSettingsUnavailable')}
      </p>
    </AdminPage>
  );
}
